// extracted by mini-css-extract-plugin
module.exports = {"note":"Note__note___11PLc","default":"Note__default___ERMGO","system":"Note__system___UwiBD","selected":"Note__selected___Aqxhx"};